import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/page/index'
import List from '@/page/list'
import myAccount from '@/page/myAccount'
import contentList from '@/page/contentList'
import faq from '@/page/faq'
import privicyPolicy from '@/page/privicyPolicy'
import termsAndCondition from '@/page/termsAndCondition'
import subscribe from '@/page/subscribe'
import Login from '@/page/Login'
import Code from '@/page/code'

Vue.use(Router)

export default new Router({
  routes: [
    {
		path: '/',
		name: 'index',
		component: Index,
		meta: {
			title: 'Study Go'
		}
    },{
		path: '/login',
		name: 'login',
		component: Login,
		meta: {
			title: 'Login'
		}
    },{
		path: '/code',
		name: 'code',
		component: Code,
		meta: {
			title: 'code'
		}
    },{
		path: '/list',
		name: 'list',
		component: List,
		meta: {
			title: 'Study Go'
		}
    },{
		path: '/myAccount',
		name: 'myAccount',
		component: myAccount,
		meta: {
			title: 'Study Go'
		}
    },{
		path: '/contentList',
		name: 'contentList',
		component: contentList,
		meta: {
			title: 'Study Go'
		}
    },{
		path: '/faq',
		name: 'faq',
		component: faq,
		meta: {
			title: 'faqs'
		}
    },{
		path: '/privicyPolicy',
		name: 'privicyPolicy',
		component: privicyPolicy,
		meta: {
			title: 'Privicy Policy'
		}
    },{
		path: '/termsAndCondition',
		name: 'termsAndCondition',
		component: termsAndCondition,
		meta: {
			title: 'Terms and Condition'
		}
    },{
		path: '/subscribe',
		name: 'subscribe',
		component: subscribe,
		meta: {
			title: 'subscribe'
		}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js